/**
 * Imports the necessary dependencies and styles for the CreateUsersManagement component.
 * @import React from "react" - The main React library.
 * @import { useTranslation } from "react-i18next" - A hook for internationalization.
 * @import PhoneInput from "react-phone-input-2" - A component for phone number input.
 * @import { Card } from "react-bootstrap" - A component for displaying a card.
 * @import "react-phone-input-2/lib/bootstrap.css" - CSS styles for the PhoneInput component.
 * @import CustomeSelect from "../../components/customeSelect/customeSelect" - A custom select component.
 * @import Breadcrumbs from "../../components/CustomeBreadcrumb/Breadcrumb
 */
import React from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import { Card } from "react-bootstrap";
import "react-phone-input-2/lib/bootstrap.css";

import CustomeSelect from "../../components/customSelect/customSelect";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import { RadioButton } from "../../components/radioButton/radioButton";
import CustomButton from "../../components/customButton/customButton";
import TextField from "../../components/textField/textField";
import HookForm from "../../components/hookForm/hookForm";
// import "./createUsersManagement.scss";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Constant from "../../util/constant";
import { Controller } from "react-hook-form";

/**
 * A functional component that renders a form for creating a user.
 * @param {{object}} props - The props object containing various functions and data needed for the component.
 * @returns The JSX elements representing the user creation form.
 */
const CreateUserComponent = (props) => {
  const { t } = useTranslation();

  /**
   * Destructures the necessary props from the given object.
   * @param {{object}} props - The object containing the props.
   * @returns None
   */
  const {
    handleFormSubmit,
    roleradioChangeHandler,
    isroleselect,
    components,
    selectInputRef,
    mobileradioChangeHandler,
    isMobileselect,
    addUserForm,
    addUserDepotName,
    onChangeDriverDepot,
    onChangeMangerDepot,
    formatOptionLabel,
    setPhoneNumbers,
    setphoneNumberError,
    phoneNumberError,
    setphoneTouched,
    phoneTouched,
    innerPagetitle,
    phoneNumbers,
    sethomeDepot,
    createUserFunction,
    backPageFunction,
    placeHolderShimer,
    loaderButtonShow,
    fullnametextcount,
    handlefullnametextcount,
    emailtextcount,
    handleEmailtextcount,
    paynumbertextcount,
    handlePaynumbertextcount,
  } = props;


  /**
   * Renders a form for creating a new user with various input fields and buttons.
   * @param {{string}} innerPagetitle - The title of the inner page.
   * @returns The JSX code for the user creation form.
   */
  return (
    <>
      <React.Fragment>
        <div className="page-content CreateUsersManagement">
          <Breadcrumbs
            breadcrumbMainTitle={false}
            breadcrumbInner={true}
            innerPagetitle={innerPagetitle}
            backPageFunction={backPageFunction}
          />
          <Card className="Main_Card Main_CreateUsers_Management">
            <Card.Body className="activeTabSupplier">
              <div className="Main_Card_Body">
                {/**
                 * Renders a form with various input fields and buttons for adding a user.
                 * @param {{defaultForm: object}} defaultForm - The default form values.
                 * @param {{string}} className - The CSS class name for the form.
                 * @param {{function}} onSubmit - The function to handle form submission.
                 * @param {{function}} init - The function to initialize the form.
                 * @returns The rendered form component.
                 */}
                <HookForm
                  defaultForm={{
                    mobileLogin: isMobileselect,
                  }}
                  className="form-horizontal"
                  onSubmit={(e) => handleFormSubmit(e)}
                  init={(form) => {
                    createUserFunction(form);
                  }}
                >
                  {(formMethod) => {
                    return (
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("FULL_NAME")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addUserForm.fullname.validate}
                                name={addUserForm.fullname.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                placeholder={t("ENTER_FULL_NAME")}
                                textCountVisible={true}
                                textcount={fullnametextcount}
                                onChange={handlefullnametextcount}
                                textCountTotal={200}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("EMAIL_ADDRESS")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addUserForm.email.validate}
                                name={addUserForm.email.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={false}
                                required={false}
                                type="text"
                                placeholder={t("ENTER_EMAIL_ADDRESS")}
                                textCountVisible={true}
                                textcount={emailtextcount}
                                onChange={handleEmailtextcount}
                                textCountTotal={200}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("PAY_NUMBER")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addUserForm.paynumber.validate}
                                name={addUserForm.paynumber.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={false}
                                required={false}
                                type="text"
                                placeholder={t("ENTER_5_DIGIT_PAY_NUMBER")}
                                textCountVisible={true}
                                textcount={paynumbertextcount}
                                onChange={handlePaynumbertextcount}
                                textCountTotal={5}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("Phone Number")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <Controller
                                name={addUserForm.phone.name}
                                rules={addUserForm.phone.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <PhoneInput
                                      className={"phoneinput textField"}
                                      placeholder={"000 000 0000"}
                                      enableSearch={true}
                                      showDropdown={false}
                                      priority={{ gb: 91 }}
                                      country={"gb"}
                                      value={phoneNumbers}
                                      countryCodeEditable={false}
                                      isValid={(value, country) => {
                                        if (!phoneTouched) {
                                          return true;
                                        } else if (
                                          /^([0-9]{8,15})$/.test(value)
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      }}
                                      onChange={(e) => {
                                        onChange(e.toString());
                                        setphoneTouched(true);
                                        setPhoneNumbers(e);
                                        if (!phoneTouched) {
                                          return true;
                                        } else if (/^([0-9]{8,15})$/.test(e)) {
                                          setphoneNumberError("");
                                        } else {
                                          if (e === "") {
                                            setphoneNumberError(
                                              t("PLEASE_ENTER_PHONE_NUMBER")
                                            );
                                            return;
                                          } else {
                                            setphoneNumberError(
                                              t(
                                                "PLEASE_ENTER_VALID_PHONE_NUMBER"
                                              )
                                            );
                                            return;
                                          }
                                        }
                                      }}
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {phoneNumberError !== "" && phoneTouched && (
                              <div className=" errorMsg show">
                                <span>{phoneNumberError}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("ROLE")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addUserForm.role.name}
                                    rules={addUserForm.role.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            roleradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="1"
                                          isSelected={
                                            isroleselect === Constant.GENERALKEYS.MANAGER
                                          }
                                          label={t("MANAGER")}
                                          value={t("MANAGER")}
                                          name="role"
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            roleradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="2"
                                          isSelected={
                                            isroleselect === Constant.GENERALKEYS.DRIVER
                                          }
                                          label={t("DRIVER")}
                                          value={t("DRIVER")}
                                          name="role"
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("MOBILE_LOGIN")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper MobileRadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addUserForm.mobileLogin.name}
                                    rules={addUserForm.mobileLogin.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            mobileradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="3"
                                          isSelected={
                                            isMobileselect === t("YES")
                                          }
                                          label={t("YES")}
                                          value={t("YES")}
                                          disabled={!isroleselect}
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            mobileradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="4"
                                          isSelected={
                                            isMobileselect === t("No")
                                          }
                                          label={t("No")}
                                          value={t("No")}
                                          disabled={
                                            isroleselect === Constant.GENERALKEYS.DRIVER  ||
                                            !isroleselect
                                          }
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("DEPOT")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <Controller
                                name={addUserForm.depot.name}
                                rules={addUserForm.depot.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <CustomeSelect
                                      ref={selectInputRef}
                                      options={addUserDepotName}
                                      closeMenuOnSelect={false}
                                      onChange={(item) => {
                                        isroleselect === Constant.GENERALKEYS.DRIVER
                                          ? onChangeDriverDepot(item)
                                          : onChangeMangerDepot(item);
                                        onChange(item);
                                      }}
                                      formatOptionLabel={formatOptionLabel}
                                      components={components}
                                      isDisabled={!isroleselect}
                                      isClearable={true}
                                      placeholder={t("SELECT")}
                                      className={
                                        isroleselect === Constant.GENERALKEYS.DRIVER
                                          ? "singleSelecter fullWidthSelect"
                                          : "multiSelecter fullWidthSelect"
                                      }
                                      isMulti={
                                        isroleselect === Constant.GENERALKEYS.DRIVER ? false : true
                                      }
                                    />
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mt-3 d-flex FormButton">
                          <div className="wrapper-input">
                            {placeHolderShimer && <CustomeShimer />}
                            <CustomButton
                              className="black-btn Fill_Button"
                              type="submit"
                              closeMenuOnSelect={false}
                              disabled={
                                isroleselect === Constant.GENERALKEYS.DRIVER
                                  ? !formMethod?.formState.isValid
                                  : (!formMethod?.formState.isValid ||
                                    !sethomeDepot)
                              }
                              loading={loaderButtonShow}
                            >
                              {t("ADD")}
                            </CustomButton>
                          </div>
                        </div>
                      </>
                    );
                  }}
                </HookForm>
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
    </>
  );
};

export default CreateUserComponent;
